import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ActivatedRoute, Route, RouterModule } from '@angular/router';
import { Observable, map } from 'rxjs';
import { UserDetails } from 'src/app/components/login/user.model';
import { LogEventsEnum } from 'src/app/firebase.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PriceTypePipe } from 'src/app/pipes/price-type.pipe';
import { SplitLocationPipe } from 'src/app/pipes/split-location.pipe';
import { ContractDetailsService } from 'src/app/services/contracts/contract-details.service';
import {
  ContractDetails,
  ContractDetailsResponse,
} from 'src/app/services/contracts/contract.model';
import { LotsService } from 'src/app/services/lots.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-contract-details',
  templateUrl: './contract-details.component.html',
  styleUrls: ['./contract-details.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatSnackBarModule,
    MatRippleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatCardModule,
    MatChipsModule,
    MatCheckboxModule,
    MatButtonToggleModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatDividerModule,
    MatIconModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatBadgeModule,
    PriceTypePipe,
  ],
})
export class ContractDetailsComponent implements OnInit {
  private analytics = inject(Analytics);
  contract$: Observable<ContractDetails>;
  isLoading: boolean;
  isCashContract = signal(null);

  constructor(
    private route: ActivatedRoute,
    private contractDetailsService: ContractDetailsService,
    private lotsService: LotsService
  ) {}

  ngOnInit(): void {
    const contractId = this.route.snapshot.paramMap.get('id');
    this.contract$ = this.contractDetailsService
      .contractDetails(contractId)
      .valueChanges.pipe(
        map((res) => {
          logEvent(this.analytics, LogEventsEnum.contracts_detail_view);
          // console.log('contract query pipe', res.data['contract']);
          this.isLoading = false;
          this.isCashContract.set(
            this.lotsService.isCashPrice(res.data['contract']['price'])
          );
          return res.data['contract'];
        })
      );
  }

  downloadPDF(contractId: string) {
    this.contractDetailsService
      .getPDF(contractId)
      .valueChanges.pipe(
        map((result) => {
          return result.data['contractPdf'];
        })
      )
      .subscribe({
        next: (result) => {
          const byteCharacters = atob(result['body']);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;
          a.download = result['filename'];
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        },
      });
  }
}
